import VehicleGroupFormLayout, { transformValues } from './form'
import GenericCreateForm from '../common/create'

export default () => (
  <GenericCreateForm formLayoutComponent={<VehicleGroupFormLayout />} transformValues={transformValues} />
)
